import { Box, Flex } from '@chakra-ui/react';
import {
  Button,
  IconButton,
  LabelText,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  TextArea,
} from '@spotoninc/nexus-react';
import { CloseIcon } from '@spotoninc/nexus-web-assets';
import { useCompleteTaskModal } from './useCompleteTaskModal';
import FeedbackBlock from '../FeedbackBlock';

import styles from './completeTaskModal.module.css';
import { FEEDBACK_STATE } from '../FeedbackBlock/FeedbackBlock';

/**
 * Render modal on use press complete button
 *
 * Parent
 *      TaskDrawer
 */
function CompleteTaskModal({ isOpen, onClose, onSubmit }) {
  const {
    textAreaLabel,
    feedbackState,
    handleFeedbackChange,
    submit,
    register,
    onSkip,
  } = useCompleteTaskModal({
    onSubmit,
    isOpen,
  });
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      className={styles.completeTaskModal}
    >
      <Flex
        alignItems={'center'}
        gap={4}
        justifyContent={'space-between'}
        className={styles.modalHeader}
      >
        <Box className={styles.headerText}>Task Details</Box>
        <IconButton
          icon={CloseIcon}
          className={styles.iconButton}
          size="small"
          onClick={onClose}
        />
      </Flex>

      <ModalBody>
        <Box mb={6}>
          <FeedbackBlock
            label="Did this help you?"
            value={feedbackState}
            align="left"
            iconAlign="flex-start"
            onThumbsUpClick={handleFeedbackChange(FEEDBACK_STATE.POSITIVE)}
            onThumbsDownClick={handleFeedbackChange(FEEDBACK_STATE.NEGATIVE)}
          />
        </Box>
        <TextArea label={textAreaLabel} {...register('comments')} />
        <LabelText size="small" className={styles.infoText}>
          Optional
        </LabelText>
      </ModalBody>
      <ModalFooter>
        <Button variant="tonal" onClick={onSkip}>
          skip
        </Button>
        <Button type="submit" onClick={submit}>
          Submit
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default CompleteTaskModal;
